import { LayoutConfig } from 'js/model/state/layout';
import { AccountRelevantReduxState } from 'js/redux-modules/account/AccountRelevantReduxState';

export const getLayoutConfig = (
  state: AccountRelevantReduxState
): LayoutConfig => (state.layout && state.layout.slice(-1).pop()) || {};
